import { render } from "./TableCompanies.vue?vue&type=template&id=6e5c807c"
import script from "./TableCompanies.vue?vue&type=script&lang=js"
export * from "./TableCompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__